import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, watch } from 'vue';
import Quill from 'quill';

interface Props {
  modelValue: string;
  label?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RichTextEditor',
  props: {
    modelValue: {},
    label: {}
  },
  emits: ['update:modelValue', 'update:embeddedImages'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const editor = ref<HTMLDivElement | null>(null);
let quill: Quill | null = null;

const embeddedImages = ref<File[]>([]);

onMounted(() => {
  quill = new Quill(editor.value as HTMLDivElement, {
    theme: 'snow',
    modules: {
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: [1, 2, 3, false] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ indent: '-1' }, { indent: '+1' }],
          ['link', 'blockquote', 'image'],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    },
  });

  const editorEl = quill.root as HTMLElement;
  editorEl.style.color = '#000';
  editorEl.style.backgroundColor = '#fff';

  if (props.modelValue) {
    editorEl.innerHTML = props.modelValue;
  }

  quill.on('text-change', () => {
    emit('update:modelValue', quill!.root.innerHTML);
  });
});

function imageHandler(this: any) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.click();

  input.onchange = async () => {
    const file = input.files?.[0];
    if (!file) return;

    const placeholderId = `image-${Date.now()}-${Math.random().toString(36).substring(2, 8)}`;

    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target?.result as string;
      const range = quill!.getSelection(true);
      quill!.insertEmbed(range.index, 'image', base64);
      quill!.setSelection(range.index + 1);

      requestAnimationFrame(() => {
        const editorEl = quill!.root as HTMLElement;
        const imgs = editorEl.querySelectorAll('img[src^="data:"]');
        const lastImg = imgs[imgs.length - 1];
        if (lastImg) {
          lastImg.setAttribute('data-temp-id', placeholderId);

          emit('update:modelValue', editorEl.innerHTML);
        }
      });

      embeddedImages.value.push(Object.assign(file, { __placeholderId: placeholderId }));
      emit('update:embeddedImages', embeddedImages.value);
    };
    reader.readAsDataURL(file);
  };
}

watch(
  () => props.modelValue,
  (newValue) => {
    if (quill && quill.root.innerHTML !== newValue) {
      quill.root.innerHTML = newValue || '';
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h6" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "mb-3" }),
      _createElementVNode("div", {
        ref_key: "editor",
        ref: editor,
        class: "quill-editor"
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})